import React, { FC } from 'react'

type Props = { className?: string }

export const AuthThemeVisual: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <img src="/img/works-theme-visual.webp" alt="認証ページイラスト" />
    </div>
  )
}
